var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-dialog",
    {
      attrs: {
        visible: _vm.visible,
        icon: "/static/icon-alert-purple.svg",
        title: "Confirme para finalizar seu pedido"
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("p", [
          _vm._v("\n      Você escolheu o dia\n      "),
          _c("b", [_vm._v(_vm._s(_vm._f("formatDate")(_vm.day, "DD/MM/Y")))]),
          _vm._v(
            ", neste dia não haverá suporte do time de atendimento!\n      Em casos de "
          ),
          _c("b", [_vm._v("Imprevistos")]),
          _vm._v(",\n      "),
          _c("b", [_vm._v("reagendamentos")]),
          _vm._v(" ou\n      "),
          _c("b", [_vm._v("cancelamentos")]),
          _vm._v(
            " nesse dia, deverá ser aberto um ticket de atendimento que será tratado\n      "
          ),
          _c("b", [_vm._v("antes")]),
          _vm._v(" ou no\n      "),
          _c("b", [_vm._v("próximo dia útil")]),
          _vm._v(". Você está ciente e deseja prosseguir?\n    ")
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nosso atendimento é de segunda à sexta das 7h30 às 21h, sábado das 8h às 16h e domingo das 10h às 13h e 16h às 19h."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "div",
            {
              staticClass: "btn bg-purple-outline",
              on: {
                click: function($event) {
                  _vm.reject()
                }
              }
            },
            [_vm._v("Não, desejo escolher outra data")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn bg-purple",
              on: {
                click: function($event) {
                  _vm.accept()
                }
              }
            },
            [_vm._v("Sim, estou ciente")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34830361", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34830361","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/WontHaveInstantSupport.vue
// module id = null
// module chunks = 